import React, { useEffect, useState } from 'react';
import { useAuth } from "../../auth";
import api from "../../api";
import { printPrice } from "../../helpers";
import CdnImage from "../../Components/CdnImage";
import './styles.css';

export default function PrintableOrderForm() {
    const [offers, setOffers] = useState([]);
    const { company } = useAuth();

    useEffect(() => {
        api.getOffers().then(setOffers);
    }, []);

    return (
        <div className="printable-order-form">
            <div className="header">
                <h1>Bestellijst - {company?.name}</h1>
                {company?.email && <p>Email: {company.email}</p>}
                {company?.phone && <p>Telefoon: {company.phone}</p>}
            </div>

            <table className="offers-table">
                <thead>
                    <tr>
                        <th className="col-image">Afbeelding</th>
                        <th className="col-product">Product</th>
                        <th className="col-price">Prijs</th>
                        <th className="col-amount">Aantal</th>
                    </tr>
                </thead>
                <tbody>
                    {offers.map((offer) => (
                        <tr key={offer.id}>
                            <td className="col-image">
                                {offer.image && (
                                    <CdnImage
                                        src={offer.image}
                                        width={80}
                                        height={80}
                                        alt={offer.title}
                                    />
                                )}
                            </td>
                            <td className="col-product">
                                <strong>{offer.title}</strong>
                                {offer.description && (
                                    <div className="description">{offer.description}</div>
                                )}
                            </td>
                            <td className="col-price">
                                {printPrice(offer.price)}
                                {offer.unit && ` per ${offer.unit}`}
                            </td>
                            <td className="col-amount">
                                <div className="amount-box"></div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="customer-form">
                <h2>Klantgegevens</h2>
                <div className="form-row">
                    <label>Naam:</label>
                    <div className="form-line"></div>
                </div>
                <div className="form-row">
                    <label>Email:</label>
                    <div className="form-line"></div>
                </div>
                <div className="form-row">
                    <label>Telefoon:</label>
                    <div className="form-line"></div>
                </div>
                <div className="form-row">
                    <label>Adres:</label>
                    <div className="form-line"></div>
                </div>

                <h3>Betaalmethode</h3>
                <div className="payment-methods">
                    <div className="checkbox-row">
                        <div className="checkbox"></div>
                        <label>Contant</label>
                    </div>
                    <div className="checkbox-row">
                        <div className="checkbox"></div>
                        <label>Tikkie (digitale betaalverzoek via WhatsApp)</label>
                    </div>
                </div>
            </div>

            <div className="print-button-container no-print">
                <button onClick={() => window.print()} className="print-button">
                    Afdrukken
                </button>
                <button onClick={() => window.close()} className="close-button">
                    Sluiten
                </button>
            </div>
        </div>
    );
}
